import React from "react";

const Title = ({ Id }) => {

    let titulo = (Id == 0 ? "Nueva Cuenta" : "Editar Cuenta");

    return (
        <div className="row">
            <div className="col-md-12">
                <h1>{titulo}</h1>
            </div>
        </div>
    );
}

export default Title